import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetUser, UpdateUser } from "../../Redux/Slices/User";
import avatar from "../../asset/new/images/avatar-1577909_1280.png";
import { useParams } from "react-router-dom";
import { FaRegEye, FaUser, FaBriefcase, FaGraduationCap, FaUserTie, FaMapMarkerAlt, FaFileAlt } from "react-icons/fa";
import { TfiDownload } from "react-icons/tfi";
import { TbReplaceFilled } from "react-icons/tb";
import toast from "react-hot-toast";
import { getProgressBarColor } from "../../Helper/CoreHelper";
import { BsFilePdf } from "react-icons/bs";
import { CreateSubFolder, GetFolder } from "../../Redux/Slices/Folder";
import "../../asset/new/css/jobseeker-profile-modern.css";

const ViewJobSeekerProfile = () => {
  const { userData, completionPercentage } = useSelector(
    (state) => state?.User
  );
  const [folders, setFolders] = useState([]);
  const [select, setSelect] = useState("");
  const dispatch = useDispatch();
  const { id } = useParams();
  const role = localStorage.getItem("role");
  //----------Resume -----------
  const [resume, setResume] = useState(null);
  const fileInputRef = useRef(null);

  //   Url Split for PDf Name
  const filePath = userData?.resume?.split("/")?.slice(-1);
  const handleFileChange = (e) => {
    setResume(e.target.files[0]);
  };

  const openFileInput = () => {
    fileInputRef.current.click();
  };

  const handleResumeUpload = async () => {
    if (resume) {
      const formData = new FormData();
      formData.append("resume", resume);

      try {
        await UpdateUser(id, formData, "multipartformdata");
        dispatch(GetUser(id));
        setResume(null);
      } catch (error) {
        console.error("Error uploading resume:", error);
        toast.error("Error uploading resume. Please try again.");
      }
    } else {
      toast.error("Add a resume file before uploading");
    }
  };
  // Url Path
  let resumeUrl = process.env.REACT_APP_AZURE_STORAGE_URL;

  // To View PDf
  const handleView = () => {
    let url = resumeUrl + userData?.resume;
    window.open(url, "_blank");
  };

  // For Download PDf
  const handleDownload = () => {
    let url = resumeUrl + userData?.resume;
    window.open(url, "_blank");
  };

  //--------- End of Resume -------

  // Industr Name
  let industryName = userData?.career?.industry
    .map((value) => value.name)
    .join("");

  // IT Name
  let itName = userData?.career?.skills
    .filter((value) => value.type === "IT")
    .map((value) => value.name)
    .join(", ");

  // FN Name
  let fnName = userData?.career?.skills
    .filter((value) => value.type === "Functional")
    .map((value) => value.name)
    .join(", ");

  //Location
  let location = userData?.career?.preferred_location
    ?.map((value) => value)
    ?.join(", ");

  useEffect(() => {
    dispatch(GetUser(id));
    document.title = "Jobseeker Profile";
    if(role === "Admin" || role === "Employer"){
      handlefolder()
    }
  }, [dispatch]);

   // Add to Folder
   const handleAddFolder = async (e) => {
    const userIds =[id];
    let data = {
      userids: userIds,
    };
    await CreateSubFolder(select, data);
  };

  // Folder List
  const handlefolder = async () => {
    let data = await GetFolder();
    setFolders(data?.docs);
  };
  return (
    <>
      <div className="jobseeker-profile-modern">
        {/* Header Section with Avatar and Profile Completion */}
        <div className="profile-header-modern">
          <div className="profile-header-content">
            <div className="profile-avatar-wrapper">
              {userData?.profile_img ? (
                <img
                  src={userData?.profile_img}
                  alt="profile"
                  className="profile-avatar-modern"
                />
              ) : (
                <img src={avatar} alt="profile" className="profile-avatar-modern" />
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h3 className="profile-name-modern">{userData?.name || "Job Seeker"}</h3>
              <div className="profile-completion-section">
                <div className="profile-completion-label">
                  <span>Profile Completion</span>
                  <span className="profile-completion-percentage">{completionPercentage}%</span>
                </div>
                <div className="profile-completion-bar">
                  <div 
                    className={`profile-completion-fill ${getProgressBarColor(completionPercentage)}`}
                    style={{ width: `${completionPercentage}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Bar */}
        {(role === "Admin" || role === "Employer") && (
          <div className="profile-action-bar">
            <button
              className="profile-action-btn profile-action-btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#addtoFolderModal"
            >
              <FaFileAlt /> Add To Folder
            </button>
          </div>
        )}

        {/* Personal Info Card */}
        <div className="profile-card-modern">
          <div className="profile-card-header">
            <div className="profile-card-icon">
              <FaUser />
            </div>
            <h3 className="profile-card-title">Personal Information</h3>
          </div>
          <div className="profile-card-body">
            <div className="profile-field">
              <div className="profile-field-label">Name</div>
              <div className="profile-field-value">{userData?.name || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Email</div>
              <div className="profile-field-value">{userData?.email || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Phone</div>
              <div className="profile-field-value">{userData?.mobile || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Experience Level</div>
              <div className="profile-field-value">{userData?.experience_level || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Date of Birth</div>
              <div className="profile-field-value">{userData?.dob || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Gender</div>
              <div className="profile-field-value">{userData?.gender || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Marital Status</div>
              <div className="profile-field-value">{userData?.marital_status || <span className="profile-field-empty">Not Available</span>}</div>
            </div>
            <div className="profile-field">
              <div className="profile-field-label">Address</div>
              <div className="profile-field-value">
                {userData?.address?.address1 ? (
                  `${userData.address.address1}${userData.address.pincode ? `, ${userData.address.pincode}` : ""}`
                ) : (
                  <span className="profile-field-empty">Not Available</span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Resume Card */}
        <div className="profile-card-modern">
          <div className="profile-card-header">
            <div className="profile-card-icon">
              <BsFilePdf />
            </div>
            <h3 className="profile-card-title">Resume</h3>
          </div>
          <div className="profile-card-body">
            {userData?.resume ? (
              <div className="profile-resume-box">
                <BsFilePdf className="profile-resume-icon" />
                <div className="profile-resume-info">
                  <div className="profile-resume-filename">{filePath}</div>
                  <div className="profile-resume-actions">
                    <button onClick={handleView} className="profile-resume-btn">
                      <FaRegEye /> View
                    </button>
                    <button onClick={handleDownload} className="profile-resume-btn">
                      <TfiDownload /> Download
                    </button>
                    {role === "Admin" && (
                      <>
                        <input
                          type="file"
                          id="fileInput"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          accept="application/pdf"
                          onChange={handleFileChange}
                        />
                        <button onClick={openFileInput} className="profile-resume-btn">
                          <TbReplaceFilled /> Replace
                        </button>
                      </>
                    )}
                  </div>
                  {resume && (
                    <button
                      onClick={handleResumeUpload}
                      className="profile-action-btn profile-action-btn-primary mt-2"
                      style={{ width: 'auto' }}
                    >
                      Upload Resume
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="profile-empty-state">No resume uploaded</div>
            )}
          </div>
        </div>

        {/* Career Profile Card */}
        {userData?.career && (
          <div className="profile-card-modern">
            <div className="profile-card-header">
              <div className="profile-card-icon">
                <FaUserTie />
              </div>
              <h3 className="profile-card-title">Career Profile</h3>
            </div>
            <div className="profile-card-body">
              <div className="profile-field">
                <div className="profile-field-label">Profile Headline</div>
                <div className="profile-field-value">{userData.career.profile_headline || <span className="profile-field-empty">Not Available</span>}</div>
              </div>
              <div className="profile-field">
                <div className="profile-field-label">Accomplishments</div>
                <div className="profile-field-value">{userData.career.accomplishments || <span className="profile-field-empty">Not Available</span>}</div>
              </div>
              <div className="profile-field">
                <div className="profile-field-label">Expected Salary</div>
                <div className="profile-field-value">
                  {userData.career.expected_salary ? 
                    `₹${userData.career.expected_salary.lac}.${userData.career.expected_salary.thousand} Lakhs` : 
                    <span className="profile-field-empty">Not Available</span>
                  }
                </div>
              </div>
              <div className="profile-field">
                <div className="profile-field-label">Industry</div>
                <div className="profile-field-value">{industryName || <span className="profile-field-empty">Not Available</span>}</div>
              </div>
              <div className="profile-field">
                <div className="profile-field-label">Preferred Location</div>
                <div className="profile-field-value">{location || <span className="profile-field-empty">Not Available</span>}</div>
              </div>
              {fnName && (
                <div className="profile-field">
                  <div className="profile-field-label">Functional Skills</div>
                  <div className="profile-field-value">
                    <div className="profile-skills-grid">
                      {fnName.split(', ').map((skill, index) => (
                        <span key={index} className="profile-skill-tag">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {itName && (
                <div className="profile-field">
                  <div className="profile-field-label">IT Skills</div>
                  <div className="profile-field-value">
                    <div className="profile-skills-grid">
                      {itName.split(', ').map((skill, index) => (
                        <span key={index} className="profile-skill-tag profile-skill-tag-primary">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Experience Card */}
        {userData?.experience && userData.experience.length > 0 && (
          <div className="profile-card-modern">
            <div className="profile-card-header">
              <div className="profile-card-icon">
                <FaBriefcase />
              </div>
              <h3 className="profile-card-title">Work Experience</h3>
            </div>
            <div className="profile-card-body">
              {userData.experience.map((exp, index) => (
                <div key={index} className="profile-experience-item">
                  <div className="profile-item-title">{exp?.designation || "Position"}</div>
                  <div className="profile-item-subtitle">{exp?.company?.name || "Company"}</div>
                  <div className="profile-item-meta">
                    <span>{exp?.duration?.from || "Start Date"} - {exp?.duration?.to || "Present"}</span>
                  </div>
                  {exp?.profile_description && (
                    <div className="profile-item-description">{exp.profile_description}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Professional Qualification Card */}
        {userData?.prof_qualification && userData.prof_qualification.length > 0 && (
          <div className="profile-card-modern">
            <div className="profile-card-header">
              <div className="profile-card-icon">
                <FaGraduationCap />
              </div>
              <h3 className="profile-card-title">Professional Qualifications</h3>
            </div>
            <div className="profile-card-body">
              {userData.prof_qualification.map((qual, index) => (
                <div key={index} className="profile-education-item">
                  <div className="profile-item-title">{qual?.degree?.name || "Degree"}</div>
                  <div className="profile-item-meta">
                    <span>Completed: {qual?.term_of_passing?.year}-{qual?.term_of_passing?.month}</span>
                    <span>• Grade: {qual?.marks || "N/A"}</span>
                    {(qual?.attempts || qual?.no_of_attempts) && (
                      <span>• Attempts: {qual.attempts || qual.no_of_attempts}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Academic Details Card */}
        {userData?.academic && userData.academic.length > 0 && (
          <div className="profile-card-modern">
            <div className="profile-card-header">
              <div className="profile-card-icon">
                <FaGraduationCap />
              </div>
              <h3 className="profile-card-title">Academic Details</h3>
            </div>
            <div className="profile-card-body">
              {userData.academic.map((edu, index) => (
                <div key={index} className="profile-education-item">
                  <div className="profile-item-title">{edu?.graduation || "Education"}</div>
                  <div className="profile-item-subtitle">{edu?.college || "Institution"}</div>
                  <div className="profile-item-meta">
                    <span>Year: {edu?.year_of_passing || "N/A"}</span>
                    <span>• Grade: {edu?.marks || "N/A"}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Modal for Add to Folder */}
      <div
        className="modal fade"
        id="addtoFolderModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Select Folder
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setSelect(e.target.value)}
                    name="type"
                  >
                    <option>Select Folder</option>
                    {folders?.map((value, index) => (
                      <option key={index + 1} value={value?._id}>
                        {value?.name}
                      </option>
                    ))}
                  </select>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                onClick={handleAddFolder}
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewJobSeekerProfile;
